import React from 'react';

const ServicesHero = () => {
  // Background image path - easily customizable
  const backgroundImage = '/images/hero-background4.jpeg';

  return (
    <section 
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
    >
      {/* Blue gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-catalina-blue/55 to-san-marino/55"></div>
      

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl font-bold mb-4 text-white">Solutions We Provide</h1>
        <p className="text-xl text-white/90">Comprehensive material handling solutions tailored to your industry needs</p>
      </div>
    </section>
  );
};

export default ServicesHero;